import Vue from "vue";
import deepmerge from "deepmerge";
import set from "lodash/set";
import get from "lodash/get";
import { _isMobile } from "@/utils";
import * as UTIL from "@/pixels/providers/utils/index";

const isProduction = PRODUCTION;

const AdobeFunctions = {
  internal(context, _callback) {
    AdobeFunctions.clearVars();
    AdobeFunctions.setConstants();
    AdobeFunctions.setOptimizations(context);
    setTimeout(_callback, 0);
  },
  callAdobeDTM(method, event) {
    /**
     * Realizar llamada al DTM
     */
    if (event !== "Page View" && event !== "Internal Link") {
      // No se debe reportar los props de application para page views
      AdobeFunctions.setApplicationProps();
    }
    try {
      window[method](event);
      // Resetear flag de pageview automático
      window._pageViewAutomatico = false;
    } catch (error) {
      Vue.$log.error("🚀 Adobe Launch error: ", error);
    }
    Vue.$log.info("🚀 Adobe Launch call: ", event);
  },
  clearVars() {
    /**
     * Limpiar las variables cuando hace falta
     */
    set(window.digitalData, "products.attributes", []);
    set(window.digitalData, "user.segment.profile", "");
    set(window.digitalData, "internalCampaign.attributes", []);
    set(window.digitalData, "page.pageInfo.level2", "");
    set(window.digitalData, "page.pageInfo.pageName", "");
    set(window.digitalData, "page.pageInfo.errorPage", "");
    set(window.digitalData, "page.pageActivity.link.name", "");
    set(window.digitalData, "application.step", "");
    set(window.digitalData, "application.state", "");
    set(window.digitalData, "application.process", "");
    set(window.digitalData, "application.typology", "");
    set(window.digitalData, "application.errorType", "");
    set(window.digitalData, "application.isQualifiedVisits", "");
    set(
      window.digitalData,
      "application",
      deepmerge(window.digitalData.application, {
        application: {
          type: "",
          name: ""
        },
        fulfillmentModel: "",
        globalApplication: ""
      })
    );
  },
  setPageInstanceId() {
    /**
     * Establecer entorno en datalayer
     */
    set(window.digitalData, "pageInstanceID", isProduction ? "pro" : "de");
  },
  setIsMobile() {
    if (_isMobile()) {
      set(window.digitalData, "user.device.mobile", "si");
    } else {
      set(window.digitalData, "user.device.mobile", "no");
    }
  },
  setSysEnv() {
    if (_isMobile()) {
      set(window.digitalData, "page.pageInfo.sysEnv", "web-movil");
    } else {
      set(window.digitalData, "page.pageInfo.sysEnv", "escritorio");
    }
  },
  setPageName(pageName) {
    let segments = [
      get(window.digitalData, "page.pageInfo.sysEnv", "escritorio"),
      "publica",
      "general",
      "referentes om"
    ];
    if (pageName) {
      segments.push(pageName);
      set(window.digitalData, "page.pageInfo.level2", pageName);
    }
    set(window.digitalData, "page.pageInfo.level1", "referentes om");
    set(window.digitalData, "page.pageInfo.pageName", segments.join(":"));
  },
  setConstants() {
    set(window.digitalData, "page.pageInfo.server", window.location.hostname);
    set(window.digitalData, "user.device.userAgent", navigator.userAgent);
    AdobeFunctions.setPageInstanceId();
    AdobeFunctions.setIsMobile();
    AdobeFunctions.setSysEnv();
  },
  setOptimizations(context) {
    if (context && context.state && context.state.adobeTargetExperience) {
      /**
       * Se especificó una experiencia de Target. Indicarla al tagging.
       * La experiencia DEBE venir de Target con el formato: `IDACTIVIDAD_EXPERIENCIA`
       * Ej: "AR072019_B"
       */
      let datosTarget = context.state.adobeTargetExperience.split("_");
      if (datosTarget.length === 2) {
        let attributes = [
          {
            idOptimization: datosTarget[0],
            experience: datosTarget[1],
            place: "",
            type: "",
            executor: "Target",
            audience: ""
          }
        ];
        set(window.digitalData, "optimization.attributes", attributes);
      }
    }
  },
  setInternalCampaign() {
    let attributes = [
      {
        location: "",
        campaignFormat: "",
        collectiveCode: "",
        campaignName: "",
        product: "",
        productCode: "",
        quantity: ""
      }
    ];
    set(window.digitalData, "internalCampaign.attributes", attributes);
  },
  setApplicationProps() {
    set(
      window.digitalData,
      "application",
      deepmerge(window.digitalData.application, {
        application: {
          type: "operativa",
          name: "referentes om"
        },
        fulfillmentModel: "online"
      })
    );
    set(window.digitalData, "application.globalApplication", "referrals");
  },
  setProfileID(context) {
    set(
      window.digitalData,
      "user.profileID",
      get(context, "state.userIdTokenizado", "")
    );
  },
  setTypology(context) {
    set(
      window.digitalData,
      "application.typology",
      UTIL.typologyAdobe(get(context, "state.tipoCampaniaSeleccionada", ""))
    );
  },
  setOffer() {
    set(window.digitalData, "application.offer", UTIL.offerAdobe());
  },
  // PAGE NAME MOMENTANEO PARA LA CAMPAÑA MUNDIAL
  setPageNameMundial(pageName) {
    let segments = [
      get(window.digitalData, "page.pageInfo.sysEnv", "escritorio"),
      "publica",
      "general",
      "toma datos",
      "mundial"
    ];
    if (pageName) {
      segments.push(pageName);
      set(window.digitalData, "page.pageInfo.level3", pageName);
    }
    set(window.digitalData, "page.pageInfo.level1", "toma datos");
    set(window.digitalData, "page.pageInfo.level2", "mundial");
    set(window.digitalData, "page.pageInfo.pageName", segments.join(":"));
  }
};

export default AdobeFunctions;
